import { useQuery } from "react-query";
import { useService } from "core/di";
import LoginService from "features/login/domain/services/LoginService";

export function useCurrentUser() {
  const loginService = useService(LoginService);
  const queryResult = useQuery("aboutMe", () => loginService.aboutMe());
  return queryResult;
}
